import {Injectable} from '@angular/core';
import {BaseService} from '../base.service';

import {HttpClient} from '@angular/common/http';


@Injectable()
export class CoreAftersalesService extends BaseService {

  constructor(_http: HttpClient, url: string) {
    super(_http, `coreserviceaftersale`, url);
  }

}

